import { Component } from 'vue';
import { TaskViewElementEnum } from '../enums';
import { HeaderItemStyleModel } from './HeaderItemStyleModel';

export class HeaderItemModel {
  /**Тип элемента */
  Type!: TaskViewElementEnum;
  /**Имя */
  Name!: string;
  /**Стиль элемента */
  Style: HeaderItemStyleModel;
  /**Иконка */
  Icon: Component;
  /**Состояние сортировки */
  StateSort?: boolean = false;

  constructor(obj?: Partial<HeaderItemModel>) {
    if (obj) Object.assign(this, obj);
  }
}
